import { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const ApiPoller = function ApiPoller(props) {
    const {
        queries,
        callback,
        interval,
        token,
    } = props;
    const [intervalId, setIntervalId] = useState();

    async function sendResult(response, statusCode, index) {
        callback(response, statusCode, index);
    }

    async function runQuery(index) {
        const query = queries[index];

        let statusCode;
        function getStatusCode(response) {
            statusCode = response.status;
        }

        fetch(query, {
            method: 'GET',
            headers: token
                ? { Authorization: `Bearer ${token}` }
                : {},
        })
            .then((response) => {
                getStatusCode(response);
                return response.json();
            })
            .then((data) => {
                sendResult(data, statusCode, index);

                // if there are more requests to run.
                if (index < queries.length - 1) {
                    runQuery(index + 1);
                }

                return data;
            })
            .catch(() => {
                if (index < queries.length - 1) {
                    runQuery(index + 1);
                }
            });
    }

    useEffect(() => {
        // we need an initial call to runQuery
        // otherwise the first api call will happen after the first interval timeout
        runQuery(0);
        const id = setInterval(() => {
            runQuery(0);
        }, interval);
        setIntervalId(id);
    }, []);

    function usePrevious(value) {
        const ref = useRef();
        useEffect(() => {
            ref.current = value;
        });
        return ref.current;
    }

    const prevqueries = usePrevious(queries);
    useEffect(() => {
        // if queries changed, clear and reset interval with new queries
        if (prevqueries !== undefined) {
            if (prevqueries[0] !== queries[0]) {
                clearInterval(intervalId);
                runQuery(0);
                const id = setInterval(() => {
                    runQuery(0);
                }, interval);
                setIntervalId(id);
            }
        }
    }, [queries]);

    return (null);
};

ApiPoller.propTypes = {
    queries: PropTypes.arrayOf(PropTypes.string).isRequired,
    callback: PropTypes.func.isRequired,
    token: PropTypes.string,
    interval: PropTypes.number,
};

ApiPoller.defaultProps = {
    interval: 3000,
    token: '',
};

export default ApiPoller;
